"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.HybridExecutorSchema = exports.HYBRID_EXECUTOR_TYPE = void 0;
const zod_1 = require("zod");
const trigger_executor_1 = require("../trigger-executor");
exports.HYBRID_EXECUTOR_TYPE = 'hybrid';
exports.HybridExecutorSchema = trigger_executor_1.TriggerExecutorSchema.extend({
    executorType: zod_1.default.literal(exports.HYBRID_EXECUTOR_TYPE),
    orchestratorId: zod_1.default.string(),
});
//# sourceMappingURL=hybrid-executor.js.map